<template>
  <div class="verify-list" :key="verifyKey">
    <div v-for="(record, recordIndex) in records" :key="recordIndex" class="verify-row">
      <span v-tip class="font-topic" style="width: 120px">{{ workflowNameList[recordIndex] }}</span>
      <div v-ps ref="verifyRecordWrapper" class="verify-record-wrapper">
        <dropdown
          :key="-1"
          trigger="hover"
          placement="bottom-start"
          :visible-arrow="true"
          width="280"
          margin-top="4"
          popover-class="verify-row-popover"
        >
          <template slot="reference">
            <div class="verify-record">
              <svg-icon icon-class="pass" style="color: #69E0AF"></svg-icon>
              <span class="font-topic">发起流程</span>
              <i class="el-icon-arrow-right" style="color: #1989FA"></i>
            </div>
          </template>
          <ul class="list-wrap">
            <li>
              <div class="person-row">
                <span class="name">{{ getUserName(record[0].userId) }}</span>
                <span class="time">{{ record[0].createAt }}</span>
              </div>
              <div class="result-row">
                <span class="result">工作流审批触发</span>
                <span class="icon"><i class="el-icon-success"></i></span>
              </div>
            </li>
          </ul>
        </dropdown>
        <dropdown
          v-for="(processItem, index) in record"
          :key="index"
          trigger="hover"
          placement="bottom-start"
          :visible-arrow="true"
          width="280"
          margin-top="4"
          popover-class="verify-row-popover"
        >
          <ul class="list-wrap">
            <li>
              <!-- 通过 -->
              <template v-if="processItem.pass === true">
                <div v-if="processItem.or" class="person-row">
                  <span class="name">{{ getUserName(processItem.verifyUserId) }}</span>
                  <span class="time">{{ processItem.finishAt }}</span>
                </div>
                <div v-else class="person-row">
                  <span
                    class="name"
                    v-for="(userId, index) in processItem.finishedUserIds"
                    :key="index"
                  >
                    <template v-if="index !== 0">、</template>
                    {{ getUserName(userId) }}
                    <span class="icon-check"><svg-icon icon-class="adopt"></svg-icon></span>
                  </span>
                </div>
                <div class="result-row">
                  <span class="result">通过</span>
                  <span class="icon"><i class="el-icon-success"></i></span>
                </div>
              </template>
              <!-- 驳回 -->
              <template v-else-if="processItem.pass === false">
                <div v-if="processItem.or" class="person-row">
                  <span class="name">{{ getUserName(processItem.verifyUserId) }}</span>
                  <span class="time">{{ processItem.finishAt }}</span>
                </div>
                <div v-else class="person-row">
                  <span
                    class="name"
                    v-for="(userId, index) in processItem.candidateUserIds"
                    :key="index"
                  >
                    <span v-if="index !== 0" v-html="'&nbsp;、'"></span>
                    {{ getUserName(userId) }}
                    <span v-if="processItem.finishedUserIds.includes(userId)" class="icon-check">
                      <svg-icon icon-class="adopt"></svg-icon>
                    </span>
                    <span v-if="processItem.verifyUserId === userId" class="icon-refuse">
                      <svg-icon icon-class="refuse"></svg-icon>
                    </span>
                  </span>
                </div>
                <div class="result-row">
                  <span class="result">驳回</span>
                  <span class="icon"><i class="el-icon-error"></i></span>
                  <span class="desc" v-html="processItem.rejectReason"></span>
                </div>
              </template>
              <!-- 撤回审批-->
              <template v-else-if="processItem.status === 'RECALLED'">
                <div class="person-row">
                  <span
                    class="name"
                    v-for="(userId, index) in processItem.candidateUserIds"
                    :key="index"
                  >
                    <span v-if="index !== 0" v-html="'&nbsp;、'"></span>
                    {{ getUserName(userId) }}
                  </span>
                </div>
                <div class="result-row">
                  <span class="result">撤回审批</span>
                  <span class="icon"><i class="el-icon-remove" style="color: #c2c5cd;"></i></span>
                </div>
              </template>
              <!-- 审批中 -->
              <template v-else>
                <div v-if="processItem.or" class="approval-people">
                  <span v-for="(userId, index) in processItem.candidateUserIds" :key="index">
                    <span v-if="index !== 0" v-html="'&nbsp;、'"></span>
                    {{ getUserName(userId) }}
                  </span>
                </div>
                <div v-else class="approval-people">
                  <span
                    class="name"
                    v-for="(userId, index) in processItem.candidateUserIds"
                    :key="index"
                  >
                    <span v-if="index !== 0" v-html="'&nbsp;、'"></span>
                    {{ getUserName(userId) }}
                    <span v-if="processItem.finishedUserIds.includes(userId)" class="icon-check">
                      <svg-icon icon-class="adopt"></svg-icon>
                    </span>
                  </span>
                </div>
                <div class="in-approval">
                  <span class="text">审批中</span>
                  <svg-icon icon-class="svgo_approval"></svg-icon>
                </div>
              </template>
            </li>
          </ul>
          <template slot="reference">
            <div class="verify-record">
              <svg-icon
                v-if="processItem.status === 'RECALLED'"
                icon-class="detail_recalled"
                style="color: #c2c5cd;font-size:18px"
              ></svg-icon>
              <svg-icon
                v-else-if="processItem.finishAt"
                icon-class="pass"
                style="color: #69E0AF"
              ></svg-icon>
              <svg-icon v-else icon-class="pending" style="color: #F8B174"></svg-icon>
              <span class="font-topic">{{ processItem.name }}</span>
              <i class="el-icon-arrow-right" style="color: #1989FA"></i>
            </div>
          </template>
        </dropdown>
      </div>
      <div class="button-wrapper">
        <base-button @click="handleCommand(recordIndex)" type="primary">
          立即处理
        </base-button>
      </div>
    </div>
    <verify-sheet-data-dialog
      ref="verifySheetDataDialog"
      :sheet-data="sheetData"
      :sheet-def="sheetDef"
      @task-verified="$emit('task-verified')"
      from="detail"
    ></verify-sheet-data-dialog>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import Dropdown from "@/components/UIComponents/Dropdown"
import { getVerifyProcessesBySheetDataId } from "@/api/project/task"
import { getUser, initUserData } from "@/utils/user"
import VerifySheetDataDialog from "@/components/VerifySheetDataDialog"
import { deepClone, randomString } from "@/utils/common"
import { getApp } from "@/api/app"

export default {
  name: "VerifyRow",
  components: {
    BaseButton,
    Dropdown,
    VerifySheetDataDialog
  },
  props: {
    sheetDef: Object
  },
  data() {
    return {
      records: [],
      sheetData: {},
      initPromise: null,
      curApp: {},
      verifyKey: null
    }
  },
  computed: {
    curAppId() {
      return this.sheetDef.appId
    },
    workflowNameList() {
      return this.records.map(record => record?.[0]?.workflow?.name || "未命名工作流")
    }
  },
  watch: {
    curAppId: {
      handler(newVal) {
        if (newVal) {
          getApp(newVal).then(app => (this.curApp = app))
        }
      },
      immediate: true
    }
  },
  created() {
    this.initPromise = initUserData(this.curAppId)
  },
  methods: {
    init(sheetData) {
      this.verifyKey = randomString(8)
      if (!sheetData?.id) return
      this.sheetData = sheetData
      this.initPromise.then(() => {
        getVerifyProcessesBySheetDataId(sheetData.id).then(records => {
          this.records = records
        })
      })
    },
    getUserName(userId) {
      return getUser(userId)?.name || "未知用户"
    },
    initScrollPosition() {
      this.$nextTick(() => {
        let dom = this.$refs.verifyRecordWrapper
        dom.scrollLeft = dom.scrollWidth
      })
    },
    handleCommand(recordIndex) {
      this.verify(this.records[recordIndex])
    },
    verify(record) {
      let latestVerify = Object.assign({}, deepClone(this._.last(record)), {
        dataId: this.sheetData.id,
        dataPath: this.curApp.name + "/" + this.sheetDef.name,
        dataTitle: this.sheetData.title
      })
      this.$refs.verifySheetDataDialog.open(latestVerify, "sheet")
    }
  }
}
</script>

<style lang="scss" scoped>
.verify-row {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 40px;
  border-bottom: 1px solid #e4e4e4;
  & > .font-topic {
    margin-right: 22px;
    flex: 0 0 auto;
  }
  .verify-record-wrapper {
    display: flex;
    height: 100%;
    align-items: center;
    margin-right: 20px;
    .icon-error {
      color: #fa5555;
    }
    .error-text {
      margin-left: 6px;
      line-height: 16px;
      color: $color-font-first;
    }
    > span {
      &:focus {
        outline: none;
      }
      &:last-of-type {
        .el-icon-arrow-right {
          display: none;
        }
      }
    }
    .verify-record {
      flex: 0 0 auto;
      margin-right: 18px;
      cursor: pointer;
      .svg-icon {
        margin-right: 6px;
      }
      .font-topic {
        margin-right: 11px;
      }
    }
  }
  .button-wrapper {
    flex: 0 0 auto;
    margin-left: auto;
  }
}
.list-wrap {
  li {
    padding: 12px 16px;
    font-size: 14px;
    line-height: 14px;
    &:not(:first-child) {
      border-top: 1px solid #e4e4e4;
    }
    .person-row {
      display: flex;
      align-items: center;
      .time {
        flex-shrink: 0;
        margin-left: 18px;
        font-size: 12px;
        color: $color-font-second;
      }
      .icon-check {
        color: #69e0af;
      }
      .icon-refuse {
        color: #fa5555;
      }
    }
    .result-row {
      margin-top: 8px;
      display: flex;
      align-items: center;
      .icon {
        margin-left: 7px;
        margin-right: 19px;
        .el-icon-error {
          color: #fa5555;
        }
        .el-icon-success {
          color: #69e0af;
        }
      }
      .desc {
        flex: 1 1;
        ::v-deep {
          p {
            margin: 0;
          }
          ol {
            padding-inline-start: 16px;
          }
          ol li {
            list-style: decimal;
          }
          ul {
            padding-inline-start: 16px;
          }
          ul li {
            list-style: disc;
          }
        }
      }
    }
    .approval-people {
      margin-bottom: 8px;
    }
    .in-approval {
      color: #f8b174;
      .text {
        margin-right: 7px;
      }
    }
  }
}
// .in-approval {
//   padding: 12px 16px;
//   line-height: 16px;

// }
</style>

<style lang="scss">
.verify-row-popover {
  .popper__arrow {
    left: 30px !important;
  }
}
</style>
